<script setup lang="ts">
import { onBeforeUnmount, onMounted, ref } from 'vue'
const online=ref(navigator.onLine)
const update=()=>online.value=navigator.onLine
onMounted(()=>{window.addEventListener('online',update);window.addEventListener('offline',update)})
onBeforeUnmount(()=>{window.removeEventListener('online',update);window.removeEventListener('offline',update)})
</script>
<template><div v-if="!online" class="offline-banner" role="alert">网络连接已断开，页面状态已保留；恢复网络后可继续操作。</div><RouterView/></template>
